import { render, staticRenderFns } from "./YcNumber.vue?vue&type=template&id=0a2f8d71&scoped=true&"
import script from "./YcNumber.vue?vue&type=script&lang=js&"
export * from "./YcNumber.vue?vue&type=script&lang=js&"
import style0 from "./YcNumber.vue?vue&type=style&index=0&id=0a2f8d71&scoped=true&lang=css&"
import style1 from "./YcNumber.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2f8d71",
  null
  
)

export default component.exports